module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABN0lEQVQ4jaWTLUtEURCGX8WoWESwyAbBj6iw5ZaLwS0Wg2AUBJsg6w/wgsFosIo/YBHEX2Aw+ImgCGo2mARZRG2PHJwrc88eRdiBgTNf73lnzhl1Kz1ACmJEUkNSJqlP0rmkK9OK9CaKC0vckjQo6V3SvKRLSQeS6pXswMDpLnAPrEb+oDPAEfACLJR+n7DGt9TNXnKxcM6BIeABuEsBPLuimoEtmr4B0xbLLLZSAkyZ4wZoOsANoG26HrUzZpf8MDgxWg2zW3RKywEMA5seINAcTQzu2NT7Zm3QT/EMxt25+IPBDvBpvsmyIDdH9g8GTcvNYwaH9s79EZPC2aHoA9hPPeMEcAacAsuJeYTP9RgNs+MnDgB7ru/wMrfAq/W9HQP/tkxhkeYk1SS1bZkuJF13vb4VkfQFWZlasmTKAwgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/orgFrMx.png
// module id = yv63
// module chunks = 1